<script lang="ts">
	import type { SCButtonTypes, AddFundsInsufficientBalanceStatus } from '$lib/home/scwallet/types';
	import type { TokenSymbol } from '$lib/types/tokens';
	import ProcessingButton from '$lib/util/ProcessingButton.svelte';
	import { toBN } from '$lib/util/util';
	import type { ethers } from 'ethers';

	export let input: string = '';
	export let fundsAmount: ethers.BigNumber = toBN('0');
	export let validation: AddFundsInsufficientBalanceStatus = {
		isInsufficient: false,
		reason: ''
	};
	export let processing: boolean = false;
	export let execute: (input: string) => Promise<void>;
	export let type: SCButtonTypes = 'Deposit';
	export let minDepositNeeded: string = '0';
	export let token: TokenSymbol;
	export let allowed: boolean = true;
</script>

{#if !allowed && type == 'Deposit'}
	<div class="mt-2">
		<button
			class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
			>Only {token} Withdraw Allowed</button
		>
	</div>
{:else if !input || input == '0' || !fundsAmount || fundsAmount.lte(0)}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
	>
		{type}
		{token}
	</button>
{:else if fundsAmount.lt(toBN(minDepositNeeded))}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
	>
		Deposit Funds <span class="text-xs">(min. deposit ${minDepositNeeded})</span>
	</button>
{:else if validation.isInsufficient}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
	>
		{validation.reason}
	</button>
{:else if processing && type === 'Deposit'}
	<div class="mt-2">
		<ProcessingButton title="Depositing" />
	</div>
{:else if processing && type === 'Withdraw'}
	<div class="mt-2">
		<ProcessingButton title="Withdrawing" />
	</div>
{:else}
	<button
		class="bg-fx-gradient-14 w-full py-4 px-5 rounded-xl squircle-xl font-semibold mt-2"
		on:click={async () => {
			await execute(input);
			input = '0';
		}}>{type} {token}</button
	>
{/if}
